'use es6';

import reduceReducers from 'ContentEditorUI/utils/reduceReducers';
import appStateReducer from 'InpageEditorUI/redux/reducers/appStateReducer';
import layoutSectionDndReducer from 'InpageEditorUI/redux/reducers/layoutSectionDndReducer';
import nodePositionsFrozenReducer from 'InpageEditorUI/redux/reducers/nodePositionsFrozenReducer';
import { enableMapSet } from 'immer';
enableMapSet();

// Allows "synced" fields that come from the parent app to live at the top level of the the state (so existing selectors from CEUI still work)
// while keeping inpage-only (mostly UX) fields separated and organized.
// Also gives the inpage-only reducers access to fields from the parent state.
const inpageStateReducerHelper = (state, action) => Object.assign({}, state, {
  layoutSectionDnd: layoutSectionDndReducer(state, action),
  nodePositionsFrozen: nodePositionsFrozenReducer(state, action)
});
export default reduceReducers(inpageStateReducerHelper, appStateReducer);